import Button from 'components/_UI/Button'
import ImageUpload from 'components/_UI/ImageUpload'
import ImageUploadBackground from 'components/_UI/ImageUploadBackground'
import Text from 'components/_UI/Text'
import React, { useState } from 'react'
import { useEffect } from 'react'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'
import buttonText from 'texts/buttons/buttonText'
import colors from 'theme/colors'

export default function ImageCover({ onToggleImage, onDeleteFile, errorImageCover, setErrorImageCover, setErrorTypeImageBackground, errorTypeImageBackground,  allowedFiles, isEdit }) {
    const [tryAgain, setTryAgain] = useState(false)

    useEffect(() => {
      
    }, [errorImageCover])

    function toggleFile(files) {
        onToggleImage(files[0]);
    }

    return (
        <ContainerCover>


            <Text size='small' marginTop={'10px'} marginBottom={'10px'} color={colors.occasionalPurple}>
                Imagem de capa (opcional)
            </Text>
            <ImageUploadBackground
                onToggleFile={toggleFile}
                onDeleteFile={() => onDeleteFile()}
                tryAgain={tryAgain}
                isEdit={isEdit}
                refreshTryAgain={() => {
                    setTryAgain(!tryAgain)
                    setErrorImageCover(false)
                }}
            />
            

            <Column verticalCenter>
                <Text name='small' marginTop={'10px'}>Arquivos permitidos: {allowedFiles}.</Text>
                <Text name='small'>Tamanho máximo permitido: 2 MB</Text>
            </Column>



            {
                errorImageCover && (
                    <Column marginTop='20px' verticalCenter>
                        <Text color={colors.danger} name='small'>Ocorreu um erro ao cadastrar a imagem</Text>
                        <Button
                            category='outline'
                            onClick={() => {
                                setTryAgain(true)
                                setErrorImageCover(false)
                            }}
                        >
                            {buttonText.tryAgain}
                        </Button>
                    </Column>
                )

            }

            {errorTypeImageBackground && (
                <Column marginTop='10px' verticalCenter>
                    <Text textAlign={'center'} name='small' color={colors.danger}>{errorTypeImageBackground}</Text>
                    <Button 
                        category='outline'
                        onClick={() =>  {
                            setTryAgain(true)
                            setErrorImageCover(false)
                            setErrorTypeImageBackground(false)
                        }}
                    > 
                        {buttonText.tryAgain}
                    </Button>
                </Column>
            )}


        </ContainerCover>
    )
}

const ContainerCover = styled(Column)`
    margin-top: 40px;
    align-items: center;
    justify-content: center;
    & > div > div {
        width: 300px;
        border-radius: 8px;
        justify-content: center;
        flex-direction: row;
    }

    & > div {
        justify-content: center;
    }

    

    & > span > div > div > p {
        display: none;
    }
`